import React from 'react';
import cn from 'classnames';

export var SkeletonLine = function SkeletonLine(_ref) {
  var bold = _ref.bold;
  return React.createElement('div', { className: cn('skeleton line', { bold: bold }) });
};

export var SkeletonCircle = function SkeletonCircle(_ref2) {
  var bold = _ref2.bold;
  return React.createElement('div', { className: cn('skeleton circle', { bold: bold }) });
};

export default {
  SkeletonLine: SkeletonLine,
  SkeletonCircle: SkeletonCircle
};